const tour = Object.freeze([
  //polizas
  {
    url: `/policy/policies`,
    title: "Mis pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#projectId",
          popover: {
            title: "Proyectos",
            description:
              "Selecciona un proyecto para poder realizar la búsqueda.",
          },
        },
        {
          element: "#sectionTooltip",
          popover: {
            title: "Estados y fechas",
            description:
              'Si deseas, puedes realizar una búsqueda específica según estados y fechas de las pólizas. <br> Si estás buscando una póliza que acabas de crear, te recomendamos que no utilices el filtro de "Estados", ya que no sabes en qué estado se va a encontrar la póliza.',
          },
        },
        {
          element: "#btnSearch",
          popover: {
            title: "Buscar",
            description:
              'Haz click en "Buscar" para realizar la búsqueda de pólizas. <br> Si la póliza recién creada aún no aparece como "Vigente", espera unos minutos y vuelve a realizar la búsqueda.',
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/crear-poliza`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#btnEmit",
          popover: {
            title: "+ Emitir",
            description:
              'Haz click en "+ Emitir" para emitir una o más pólizas completando el formulario de emisión.',
          },
        },
        {
          element: "#btnModel",
          popover: {
            title: "Descarga Modelo Excel",
            description:
              "Para emitir pólizas de forma masiva, acá puedes descargar el modelo excel.",
          },
        },
        {
          element: "#btnMassive",
          popover: {
            title: "Carga Masiva",
            description:
              "Este botón te permite realizar la carga de tu archivo excel completado.",
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/confirm`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionProject",
          popover: {
            title: "Cotización",
            description:
              "Acá puedes conocer el detalle de la cotización de las pólizas a emitir, ordenadas por Empresa y Proyecto.",
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/emission`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#btnSeePending",
          popover: {
            title: "Ver Póliza",
            description:
              'La(s) póliza(s) puede(n) tardar unos minutos en emitirse. Presiona "Ver" para conocer su estado.',
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/payment-schedule/`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionOptions",
          popover: {
            title: "Calendarios de Pago",
            description:
              "El calendario de cuotas con fecha de pago distintas, permite agregar cuotas una a una. <br> El calendario de cuotas con fechas periódicas de pago, permite agregar más de una cuota de forma automática.",
          },
        },
        {
          element: "#sectionFees",
          popover: {
            title: "Cuotas con fechas de pago distintas",
            description:
              'Ingresa la fecha de pago de la cuota y el Monto UF asociado. Al presionar "Agregar"  aparecerá en una tabla la cuota ingresada.',
          },
        },
        {
          element: "#periodicPayment",
          popover: {
            title: "Calendario con fechas periódicas de pago",
            description:
              'Para ver cómo agregar varias cuotas de forma automática, haz click en "Periódicas".',
          },
        },
        {
          element: "#sectionFees",
          popover: {
            title: "Cuotas con fechas periódicas de pago",
            description:
              'Ingresa el Monto total UF, la cantidad de cuotas en que se dividirá este monto, la fecha del primer pago y el día de cada mes en que se pagarán las cuotas. <br> Al presionar "Agregar" aparecerá una tabla con el detalle de cada cuota.',
          },
        },
        {
          element: "#insuredAmount",
          popover: {
            title: "Monto asegurado UF",
            description:
              "Corresponde a la suma de todos los montos (UF) de las cuotas ingresadas.",
          },
        },
        {
          element: "#premium",
          popover: {
            title: "Prima única a pagar (Con IVA)",
            description:
              "Corresponde a la suma de las primas de cada cuota + IVA.",
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/validacion`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#btnErrors",
          popover: {
            title: "Errores",
            description:
              'El botón de "Errores" se activará cuando exista alguna información que deba ser modificada. Debes seleccionarlo para conocer el detalle de los errores.',
          },
        },
        {
          element: ".actions div:first-child",
          popover: {
            title: "Editar",
            description:
              "El botón de editar permite volver al formulario y editar la información de la póliza.",
          },
        },
        {
          element: ".actions div:nth-child(2)",
          popover: {
            title: "Calendario de pago",
            description: "Botón editar calendario de pago.",
          },
        },
        {
          element: ".actions div:nth-child(3)",
          popover: {
            title: "Eliminar",
            description: "Botón eliminar póliza.",
          },
        },
        {
          element: "#btnVerify",
          popover: {
            title: "Verificar Información",
            description:
              'Para poder continuar, debes hacer click en "Verificar información".',
          },
        },
      ],
    },
  },
  {
    url: `/policy/create/una-a-una/`,
    title: "Emitir pólizas",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#policyInfoForm",
          popover: {
            title: "Información básica de la póliza",
            description:
              "Ingresa la información básica de la póliza. Debes agregar una a una las propiedades a asegurar. <br> En identificación de la propiedad debes indicar los números y/o letras que identifican la propiedad a asegurar. Ej: 301.",
          },
        },
        {
          element: "#sectionBeneficiaries",
          popover: {
            title: "Promitente comprador",
            description:
              'En esta parte del formulario, se ingresa la información del Promitente comprador. <br> El botón "+ Comprador", permite agregar un Promitente comprador adicional.',
          },
        },
      ],
    },
  },
  //proyectos
  {
    url: `/project/mis-proyectos`,
    title: "Mis proyectos",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionButtonForm",
          popover: {
            title: "Proyectos, estados y fechas",
            description:
              'Puedes buscar un proyecto en específico, como también filtrar por estados y/o fechas. <br> Después de seleccionar los filtros, debes presionar "Buscar".',
          },
        },
        {
          element: "#btnNewProject",
          popover: {
            title: "Crear proyecto",
            description:
              'Para crear un nuevo proyecto, debes hacer click en "Crear proyecto".',
          },
        },
      ],
    },
  },
  {
    url: `/project/client/`,
    title: "Crear proyecto",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionRadioBtn",
          popover: {
            title: "Nuevo proyecto",
            description:
              "Debes indicar si el nuevo proyecto está asociado a una empresa diferente a la mencionada: <br> Opción No: se habilita el botón siguiente para continuar con el siguiente paso. <br> Opción Si: Se habilita el campo de “Empresa vinculada con el proyecto” para ingresar la empresa asociada al proyecto.",
          },
        },
      ],
    },
  },
  {
    url: `/project/costs-and-financing/`,
    title: "Crear proyecto",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionCostsAndFinancing",
          popover: {
            title: "Costos y financiamiento ",
            description:
              "Ingresa los costos y financiamiento asociados al proyecto. Los valores deben coincidir con el permiso de edificación.",
          },
        },
      ],
    },
  },
  {
    url: `/project/detail/`,
    title: "Crear proyecto",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionDetail",
          popover: {
            title: "Otros detalles",
            description:
              'Ingresa la información solicitada del proyecto, los campos que no apliquen déjalos en cero. <br> Si tu proyecto tiene más de una torre, debes ingresar el nombre y la cantidad de pisos de cada una; luego presionar "+" para agregarla.',
          },
        },
      ],
    },
  },
  {
    url: `/project/documentation/`,
    title: "Crear proyecto",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionDocumentation",
          popover: {
            title: "Documentación",
            description:
              "Debes agregar toda la documentación solicitada para poder continuar.",
          },
        },
      ],
    },
  },
  {
    url: `/project/general/`,
    title: "Crear proyecto",
    descriptions: "Selecciona el paso a paso de lo que deseas hacer.",
    show: true,
    driver: {
      nextBtnText: "Próximo",
      prevBtnText: "Anterior",
      doneBtnText: "Hecho",
      showProgress: true,
      steps: [
        {
          element: "#sectionProject",
          popover: {
            title: "Información general del proyecto",
            description:
              "Debes ingresar la información básica del proyecto. Para agregar la constructora debes buscar por RUT o Razón social y seleccionar una empresa del listado.",
          },
        },
      ],
    },
  },
]);
module.exports = tour;
